import useDates from "@/libs/dates/useDates";

/**
 * Returns a string representation of a date and time.
 *
 * @deprecated Use @/libs/dates/useDates instead. This function will be removed in the future.
 *
 * @param {string} date
 * @param {string} [formatStr]
 * @returns {string}
 */
export function dateAndTime(date, formatStr = "MM/DD/YYYY LTS [ET]") {
    const {format} = useDates();

    return format(date, formatStr);

    // old code....
    const datetime = window.moment(date ?? null);
    if (datetime.isValid()) {
        return datetime.format(format);
    }
    return '';
}

/**
 * Returns a string representation of a date.
 *
 * @deprecated Use @/libs/dates/useDates instead. This function will be removed in the future.
 *
 * @param {string} date
 * @param {string} [format]
 * @returns {string}
 */
export function date(date, format = "MMM DD, YYYY") {
    return dateAndTime(date, format);
}

/**
 * Returns a string representation of a time.
 *
 * @deprecated Use @/libs/dates/useDates instead. This function will be removed in the future.
 *
 * @param {string} date
 * @param {string} [format]
 * @returns {string}
 */
export function time(date, format = "LTS [ET]") {
    return dateAndTime(date, format);
}
